// @ts-nocheck
import { TAX_REPORT_ALL_DATA_CLEARED, TAX_REPORT_DAY_DATA_CHANGED, TAX_REPORT_MONTH_DATA_CHANGED } from '../types';

const initialFirstGroupState = {
    reports: [],
    summary: {},
};

const initialState = {
    firstGroup: initialFirstGroupState,
    secondGroup: {},
};

const taxReport = (state = initialState, action) => {
    const { payload } = action;
    switch (action.type) {
        case TAX_REPORT_MONTH_DATA_CHANGED: {
            return {
                ...state,
                firstGroup: {
                    ...state.firstGroup,
                    ...payload,
                },
            };
        }
        case TAX_REPORT_DAY_DATA_CHANGED: {
            return {
                ...state,
                secondGroup: {
                    ...state.secondGroup,
                    [payload.day]: payload.items,
                },
            };
        }
        case TAX_REPORT_ALL_DATA_CLEARED: {
            return {
                ...state,
                firstGroup: initialFirstGroupState,
                secondGroup: initialState.secondGroup,
            };
        }
        default:
            return state;
    }
};
export default taxReport;
